// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xd1G","newExpiryDate":"styles_newExpiryDate__QYfzk","footer":"styles_footer__5uAze"};